













/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import PersonAvatar from '@/components/global/avatar.vue'
import { IPersonBase } from '@/api/types/response.types'

/* Helpers */

/* Data types */

/* API */

/**
 * DdMember component displays user/company information
 * such as its avatar image (DdAvatar) and name/company/description.
 */
export default Vue.extend({
  name: 'DdMember',

  components: {
    PersonAvatar,
  },

  props: {
    person: {
      type: Object as () => IPersonBase,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    company: {
      type: String,
      default: '',
    },
    isCurrentUser: {
      type: Boolean,
      default: false,
    },
    avatarSize: {
      type: Number,
      default: 24,
    },
  },
})
